import fetch from 'isomorphic-fetch';
import { apiQueryShopsByIds } from '@lib/apiQueries';

export const isUserLoggedIn = (user) => {
  return Boolean(user && user.collectorNumber);
};

export const saveOffer = (offerId, endDate, callback = () => { console.log('Saved Offer'); }) => {
  const fetchOptions = {
    method: 'post',
    credentials: 'include',
    mode: 'same-origin',
    headers: {
      data: JSON.stringify({
        id: offerId,
        endDate,
      }),
    },
  };
  const fetchUrl = `/api/fav/offer`;

  return fetch(fetchUrl, fetchOptions).then(() => {
    callback();
  });
};

export const saveShop = (shopId, active, callback = () => { console.log('Saved Shop'); }) => {
  const fetchOptions = {
    method: 'post',
    credentials: 'include',
    mode: 'same-origin',
    headers: {
      data: JSON.stringify({
        id: shopId,
        active,
      }),
    },
  };
  const fetchUrl = '/api/fav/shop';

  return fetch(fetchUrl, fetchOptions).then(() => {
    callback();
  });
};

export const saveInterrupt = (shopId, dateAdded, callback = () => { console.log('Saved Interrupt'); }) => {
  const fetchOptions = {
    method: 'post',
    credentials: 'include',
    mode: 'same-origin',
    headers: {
      data: JSON.stringify({
        id: shopId,
        dateAdded,
      }),
    },
  };
  const fetchUrl = '/api/fav/interrupt';

  return fetch(fetchUrl, fetchOptions).then(() => {
    callback();
  });
};

export const removeOfferById = (offerId, callback = () => { console.log('Removed Offer'); }) => {
  if (window?.document?.cookie) {
    const fetchOptions = {
      method: 'delete',
      credentials: 'include',
      mode: 'same-origin',
      headers: { cookie: window.document.cookie },
    };
    const fetchUrl = `/api/fav/offer/${offerId}`;

    return fetch(fetchUrl, fetchOptions).then(() => {
      callback();
    });
  }
  return Promise.reject(new Error('No cookie found in window.document.'));
};

export const removeShopById = (shopId, callback = () => { console.log('Removed Shop'); }) => {
  if (window?.document?.cookie) {
    const fetchOptions = {
      method: 'delete',
      credentials: 'include',
      mode: 'same-origin',
      headers: { cookie: window.document.cookie },
    };
    const fetchUrl = `/api/fav/shop/${shopId}`;

    return fetch(fetchUrl, fetchOptions).then(() => {
      callback();
    });
  }
  return Promise.reject(new Error('No cookie found in window.document.'));
};

export const removeInterruptById = (shopId, callback = () => { console.log('Removed Interrupt'); }) => {
  if (window?.document?.cookie) {
    const fetchOptions = {
      method: 'delete',
      credentials: 'include',
      mode: 'same-origin',
      headers: { cookie: window.document.cookie },
    };
    const fetchUrl = `/api/fav/interrupt/${shopId}`;

    return fetch(fetchUrl, fetchOptions).then(() => {
      callback();
    });
  }
  return Promise.reject(new Error('No cookie found in window.document.'));
};

export async function getFullUserData(locale = 'en') {
  let userData = {};
  let userShopsData = [];

  const apiOptions = {
    method: 'GET',
    credentials: 'include',
    mode: 'same-origin',
  };

  try {
    const userRes = await fetch('/api/user', apiOptions);
    if (userRes.ok) {
      userData = await userRes.json();
    }

    if (userData?.shops?.length) {
      const favShopIds = userData.shops.map((shop) => shop.id);
      const shopsRes = await apiQueryShopsByIds(favShopIds, locale);
      if (shopsRes?.data?.shopsByIds) {
        userShopsData = shopsRes.data.shopsByIds;
      }
    }
  } catch (err) {
    console.error('Error fetching user session data:', err);
  }

  return { userData, userShopsData };
}
